<template>
  <el-dialog title="修改订单" :visible.sync="dialogFormVisible" width="600px">
    <el-form
      ref="dataForm"
      :rules="rules"
      :model="temp"
      label-position="left"
      label-width="110px"
      style="margin: 0 30px"
    >
      <template>
        <el-form-item label="订单编号">
          <p class="item-p">{{ temp.ota_sn }}</p>
        </el-form-item>
        <el-form-item label="订单类型">
          <p class="item-p">{{ temp.trip_type === 1 ? '拼团' : '包团' }}</p>
        </el-form-item>
        <el-form-item label="出发日期" prop="use_date">
          <el-date-picker
            v-model="temp.use_date"
            type="date"
            placeholder="选择出发日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="场次" prop="interval_time">
          <TimeSelect
            v-model="temp.interval_time"
            @changeInterval="(e) => (temp.interval_time = e)"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="项目" prop="project_id">
          <el-select v-model="temp.project_id" filterable placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in project_options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系人姓名" prop="contact.name">
          <el-input v-model="temp.contact.name" />
        </el-form-item>
        <el-form-item label="联系人电话" prop="contact.mobile">
          <el-input type="mobile" v-model="temp.contact.mobile" maxlength="11" />
        </el-form-item>

        <el-form-item label="城市" prop="city">
          <CitySelect
            customStyle="width: 100%"
            v-model="temp.city"
            @onChange="(e) => (temp.city = e)"
          />
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取消</el-button>
      <el-button type="primary" @click="saveData">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getBrief, edit } from '@/api/orders'
import { getList as getProjectList } from '@/api/projects'
import TimeSelect from '@/components/TimeSelect'
import CitySelect from '@/components/CitySelect'
const rule = [{ required: true, message: '必填项不能为空' }]
export default {
  name: 'OrdersEdit',
  components: {
    TimeSelect,
    CitySelect
  },
  data() {
    return {
      dialogFormVisible: false,
      sn: '',
      temp: {
        ota_sn: '',
        trip_type: null,
        use_date: '',
        interval_time: '',
        project_id: '',
        contact: { name: '', mobile: '' },
        city: ''
      },
      rules: {
        ota_sn: rule,
        trip_type: rule,
        use_date: rule,
        interval_time: rule,
        project_id: rule,
        'contact.name': rule,
        'contact.mobile': rule
      },

      project_options: []
    }
  },

  created() {
    getProjectList({ size: 1000 }).then((res) => {
      this.project_options = res.data.results
    })
  },
  methods: {
    // 编辑
    handleEdit(sn) {
      getBrief(sn).then((res) => {
        this.sn = sn
        Object.assign(this.temp, res.data)
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs.dataForm.clearValidate()
        })
      })
    },
    // 保存
    saveData() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          if (!/^(1[3-9]\d{9})$/.test(this.temp.contact.mobile)) {
            return this.$message.error('请输入正确的手机号!')
          }
          const d = JSON.parse(JSON.stringify(this.temp))
          edit(this.sn, d).then(() => {
            this.$parent.fetchData()
            this.dialogFormVisible = false
            this.$parent.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success'
            })
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.item-p {
  margin: 0;
  /* height: 1px; */
}
</style>
